$(document).on("formvalid.zf.abide", (event, form) => {
  const city = window.location.href.split("/")[3];

  const gaAction = "cta_send";
  const gaCategory = "send_info";
  const numberPeopleValue = form.find("#number_people").val();
  const emailValue = form.find("input:eq(2)").val();

  const fqbEventName = "Lead";
  const fqbContentCategory = "art";
  const fqbContentName = `Van Gogh: The Immersive Experience ${city}`;
  const fqbCurrency = "USD";

  gtag("event", gaAction, {
    event_category: gaCategory,
    event_label: numberPeopleValue,
  });

  fbq("init", window.fb_pixel_ID, {
    em: emailValue,
  });

  fbq("track", fqbEventName, {
    content_category: fqbContentCategory,
    content_name: fqbContentName,
    currency: fqbCurrency,
    value: 0,
  });
});
